import axios from '../axios'

//公司数据
export const company = (data) => {
  return axios({
    url: '/data/board/company',
    method: 'GET',
    data
  })
}

//教育局数据
export const userStat = (data) => {
  return axios({
    url: '/con/index/userStat',
    method: 'GET',
    data
  })
}
//学校数据
export const school = (data) => {
  return axios({
    url: '/data/board/school',
    method: 'GET',
    data
  })
}

//通知列表
export const noticeList = (data) => {
  return axios({
    url: '/data/board/notice/list',
    method: 'GET',
    data
  })
}

//政策通知详情
export const getPolicyNoticeDetail = (data) => {
  return axios({
    url: '/con/notice/getPolicyNoticeDetail',
    method: 'GET',
    data
  })
}
//教务通知详情
export const getEduNoticeDetail = (data) => {
  return axios({
    url: '/con/notice/getEduNoticeDetail',
    method: 'GET',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/homePage.js